import React from 'react';
import { XIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { problems } from '../data/content';
export function Problems() {
  return <section className="w-full border-t border-navy/10 bg-white px-5 py-20 sm:px-8" data-id="element-151" data-mp="36xuakwomj5m9">
      <div className="mx-auto w-full max-w-5xl" data-id="element-152" data-mp="3237z6tijld26">
        <Reveal data-id="element-153" data-mp="2y3z51njlbd63">
          <h2 className="mx-auto max-w-3xl text-center font-display text-3xl font-extrabold leading-tight tracking-tight text-navy sm:text-4xl" data-id="element-154" data-mp="2y2eba053ny9a">
            If you coach flag football, you're probably living{' '}
            <span className="text-brand-strong" data-id="element-155" data-mp="2o4i39h7gljfe">one of these problems.</span>
          </h2>
        </Reveal>

        <ul className="mt-12 grid gap-4 md:grid-cols-2" data-id="element-156" data-mp="2j6oucgerubbf">
          {problems.map((problem, index) => <Reveal key={problem} delay={index % 2 * 0.05} className="h-full" data-id="element-157" data-mp="2f6efsfcwycky" data-mpi={index}>
              <li className="flex h-full items-start gap-3 rounded-card bg-tint px-5 py-5" data-id="element-158" data-mp="hdin2o9845d6">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand/15" data-id="element-159" data-mp="dejjb6z8aenb">
                  <XIcon className="h-3.5 w-3.5 text-brand-deep" aria-hidden="true" data-id="element-160" data-mp="34pa8iusw77m3" />
                </span>
                <span className="text-md font-semibold leading-snug text-navy" data-id="element-161" data-mp="39r96tq9rzec6">
                  {problem}
                </span>
              </li>
            </Reveal>)}
        </ul>

        <Reveal delay={0.08} data-id="element-162" data-mp="2zs1yjhhwe9vx">
          <p className="mt-14 text-center font-display text-2xl font-extrabold leading-tight tracking-tight text-brand-strong sm:text-3xl" data-id="element-163" data-mp="3nhcos51mglvt">
            How many more seasons do you want to keep improvising?
          </p>
        </Reveal>
      </div>
    </section>;
}